import { render, staticRenderFns } from "./MembersDiamond.vue?vue&type=template&id=190ad333&scoped=true&"
import script from "./MembersDiamond.vue?vue&type=script&lang=js&"
export * from "./MembersDiamond.vue?vue&type=script&lang=js&"
import style0 from "./MembersDiamond.vue?vue&type=style&index=0&id=190ad333&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190ad333",
  null
  
)

export default component.exports